import { useEffect } from 'react';

import type { scaleLinear, scaleUtc } from '@visx/scale';

import { LinePlot, AreaPlot } from '../TimeseriesPlot';

import { getTrend } from '../../utils';

import type { Period } from '../../types';

interface Props {
  data: [Date, number][];
  xScale: ReturnType<typeof scaleUtc<number>>;
  yScale: ReturnType<typeof scaleLinear<number>>;
  period: Period;
  index: number;
  setIndex: (index: number) => void;
}

const getFill = (trend: ReturnType<typeof getTrend>) => {
  if (trend === 'positive') return 'url(#positive-chart)';
  if (trend === 'negative') return 'url(#negative-chart)';
};

const getStrokeColor = (trend: ReturnType<typeof getTrend>) => {
  if (trend === 'positive') return 'var(--s-color-good)';
  if (trend === 'negative') return 'var(--s-color-bad)';
  return 'var(--s-color-p-white-100)';
};

export const PortfolioPerformanceTimeseriesPlot = ({
  data,
  xScale,
  yScale,
  period,
  setIndex,
}: Props) => {
  useEffect(() => {
    setIndex(data.length - 1);
  }, [period, data, setIndex]);
  const trend = getTrend(data);
  const fill = getFill(trend);
  const strokeColor = getStrokeColor(trend);
  return (
    <svg aria-label="Portfolio Performance Timeseries Plot">
      <LinePlot
        data={data}
        xScale={xScale}
        yScale={yScale}
        strokeColor={strokeColor}
        opacity={1}
      />
      {trend !== 'neutral' && (
        <AreaPlot
          data={data}
          xScale={xScale}
          yScale={yScale}
          fill={fill}
          fillOpacity={0.9}
        />
      )}
    </svg>
  );
};
